import { startFileRecordRefresh } from "@/api/fileRecordRefresh";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";

/** Keeps the app's file-record rows fresh. */
export function FileRecordRefreshProvider() {
  const queryClient = useQueryClient();

  useEffect(() => startFileRecordRefresh(queryClient), [queryClient]);

  return null;
}
